import { v4 } from 'uuid';

export class DomParser {
  constructor(domSelector) {
    if (domSelector && typeof domSelector === 'string') {
      this.cols = document.querySelectorAll(domSelector);
    }
  }

  get columns() {
    return this.cols;
  }

  singleAnchor(el) {
    const a = el.querySelector('a');
    const text = a.textContent;
    const actionId = v4();
    a.setAttribute('action-id', actionId);

    return {
      text,
      actionId
    }
  }

  multiAnchor(el) {
    const aEls = el.querySelectorAll('a');
    const aLs = [];

    for (let i = 0; i < aEls.length; i++) {
      const a = aEls[i];
      const text = a.textContent;
      const url = a.getAttribute('href');
      const actionId = v4();
      a.setAttribute('action-id', actionId);

      if (!(text && url)) {
        continue;
      }

      aLs.push({
        text,
        actionId
      });
    }

    return aLs;
  }

  text(el) {
    return el.textContent;
  }

  textSpan(el) {
    return el.querySelector('span').textContent;
  }

  dateSpan(el) {
    const text = this.textSpan(el);
    return new Date(text);
  }

  imgSrc(el) {
    return el.querySelector('img').getAttribute('src')
  }
}



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/utils/dom-parser.js